import styled from 'styled-components';

export const MembersContainer = styled.div`
    padding: 20px;
`;

export const MembersList = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin-top: 16px;
`;

export const Avatar = styled.div`
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background: ${props => props.src ? 'none' : '#3B444C'};
    background-image: ${props => props.src ? `url(${props.src})` : 'none'};
    background-size: cover;
    background-position: center;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #B6C2CF;
    font-weight: bold;
    font-size: 14px;
`;

export const MemberItem = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px;
    background: #22272B;
    border-radius: 3px;
    gap: 12px;

    &:hover {
        background: #282E33;
    }
`;

export const MemberInfo = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    min-width: 0;
    flex: 1;
`;

export const UserDetails = styled.div`
    display: flex;
    flex-direction: column;
    min-width: 0;
    flex: 1;
`;

export const UserName = styled.div`
    font-weight: 500;
    color: #B6C2CF;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;

export const UserEmail = styled.div`
    font-size: 12px;
    color: #8C9BAB;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;

export const Actions = styled.div`
    display: flex;
    gap: 8px;
    align-items: center;
    flex-shrink: 0;
`;

export const RoleSelect = styled.select`
    padding: 6px 8px;
    border: 2px solid #3B444C;
    border-radius: 3px;
    background: #22272B;
    color: #B6C2CF;
    cursor: pointer;
    flex-shrink: 0;

    &:hover:not(:disabled) {
        background: #282E33;
        border-color: #465059;
    }

    &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }

    option {
        background: #22272B;
        color: #B6C2CF;
    }
`;

export const AddMemberForm = styled.form`
    display: flex;
    gap: 8px;
    margin-bottom: 16px;
`;

export const Input = styled.input`
    flex: 1;
    padding: 8px 12px;
    border: 2px solid #3B444C;
    border-radius: 3px;
    font-size: 14px;
    background: #22272B;
    color: #B6C2CF;
    
    &::placeholder {
        color: #8C9BAB;
    }
    
    &:focus {
        border-color: #579DFF;
        outline: none;
    }
`;

export const Button = styled.button`
    padding: 8px 16px;
    background: #579DFF;
    color: white;
    border: none;
    border-radius: 3px;
    cursor: pointer;
    font-size: 14px;

    &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }

    &:hover:not(:disabled) {
        background: #398BFF;
    }
`;

export const RemoveButton = styled.button`
    padding: 6px;
    background: none;
    border: none;
    color: #8C9BAB;
    cursor: pointer;
    border-radius: 3px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;

    &:hover:not(:disabled) {
        background: #FF5630;
        color: white;
    }

    &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }
`;

export const Error = styled.div`
    color: #FF5630;
    margin-top: 8px;
    font-size: 14px;
`;

export const SectionTitle = styled.h3`
    margin: 0 0 16px 0;
    color: #B6C2CF;
    font-size: 16px;
    font-weight: 500;
`;